export default "__VITE_ASSET__CTmMot_M__";